import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import { trackLockedWidgetSeen, trackLockedWidgetUpgradeClicked } from '../../services/analytics';

const PLAN_LABELS = {
  basic: 'Basic',
  pro: 'Pro',
  elite: 'Elite',
};

/**
 * Overlay component shown when a widget is locked behind a paywall.
 * Spans the same dimensions as the actual widget.
 * @param {string} requiredPlan - The minimum plan needed (e.g., 'basic', 'pro', 'elite')
 */
const LockedWidgetOverlay = ({ title, benefit, fullWidth = false, requiredPlan = 'pro' }) => {
  const planLabel = PLAN_LABELS[requiredPlan] || 'Pro';

  useEffect(() => {
    trackLockedWidgetSeen({ widget_title: title, required_plan: requiredPlan });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`bg-card border border-border rounded-lg p-4 md:p-6 relative overflow-hidden ${fullWidth ? 'w-full' : ''}`}>
      {/* Blurred background effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/50 to-background/80 pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-64 gap-4 text-center">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/20">
          <Lock className="w-6 h-6 text-primary" />
        </div>

        <div>
          <div className="inline-block px-2 py-1 mb-2 text-xs font-semibold text-primary bg-primary/10 rounded">
            {planLabel} Feature
          </div>
          <h3 className="text-base font-semibold text-foreground mb-1">{title}</h3>
          <p className="text-xs text-muted-foreground max-w-xs">
            {benefit}
          </p>
        </div>

        <Link
          to="/pricing"
          onClick={() => trackLockedWidgetUpgradeClicked({ widget_title: title, required_plan: requiredPlan })}
          className="inline-flex items-center gap-2 px-4 py-2 mt-2 text-sm font-medium text-primary bg-primary/10 hover:bg-primary/20 rounded-lg transition-colors"
        >
          Upgrade to {planLabel}
          <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </div>
  );
};

export default LockedWidgetOverlay;
